import React from 'react';
import { FieldProps } from 'formik';
import { TextFieldProps } from '@lifeomic/chroma-react/components/TextField';
import { FormikMaskedTextField } from '../MaskedTextField';
import { countryCodePhoneNumberFormat } from '../../util/getValidators';
import { SupportedIntlPhoneNumberValidation } from '../../common/types/Projects';

export const phoneNumberInputMask = [
  '+',
  /1/,
  ' ',
  '(',
  /[1-9]/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export interface PhoneNumberTextFieldOwnProps {
  validateInput: (val: string) => string;
  input?: TextFieldProps;
  disabled?: boolean;
  intlFormat?: SupportedIntlPhoneNumberValidation;
}

export type PhoneNumberTextFieldProps = FieldProps &
  PhoneNumberTextFieldOwnProps;

const PhoneNumberTextField = (props: PhoneNumberTextFieldProps) => {
  const { validateInput, disabled, intlFormat = 'us', ...toPass } = props;

  /*
    Check if the input is a valid phone number but does not conform to the input mask.
    This can occur if a user entered a valid phone number before the input mask was introduced
    or if the browser autofilled a phone number that doesn't conform to the mask.
  */
  const isValidLegacyValue = (value: string) =>
    !validateInput(value) && !countryCodePhoneNumberFormat.test(value);

  const getInputMask = (rawValue: string) => {
    if (intlFormat !== 'none' && (!rawValue || !isValidLegacyValue(rawValue)))
      return phoneNumberInputMask;

    // create a mask that will match the valid inputted phone number exactly
    return new Array(rawValue.length).fill(/.*/);
  };

  return (
    <FormikMaskedTextField
      {...toPass}
      mask={getInputMask}
      placeholder={intlFormat === 'none' ? '' : '+1 (234) 567-8901'}
      placeholderChar={'_'}
      guide={intlFormat !== 'none'}
      disabled={disabled}
    />
  );
};

export default React.memo(PhoneNumberTextField);
